export const tablet = "768px";
export const laptop = "1024px";
export const laptopL = "1440px";
export const desktop = "2560px";
